import React, { useState, useEffect } from 'react';
import { styled } from '@goodrx/matisse';
import { PaymentRequestButtonElement, useStripe } from '@stripe/react-stripe-js';
import * as Sentry from '@sentry/browser';
import * as stripeJs from '@stripe/stripe-js';
import { PaymentRequest } from 'app/components/payment/types';
import { onPaymentRequestSubmitted, onPaymentRequestFailed, onPaymentRequestButtonDisplayed } from 'app/lib/analytics';

const PaymentRequestButton = styled(PaymentRequestButtonElement)`
  margin-bottom: 32px;
`;

export const PaymentRequestMain = ({ amount, onTokenReceived }: PaymentRequest) => {
  const stripe = useStripe();
  const [paymentRequest, setPaymentRequest] = useState<stripeJs.PaymentRequest | undefined>();

  const handlePaymentRequestToken = async ({ token, complete, methodName }: stripeJs.PaymentRequestTokenEvent) => {
    try {
      await onTokenReceived(token.id);
      complete('success');
      onPaymentRequestSubmitted({ methodName });
    } catch (e) {
      Sentry.captureException(e);
      complete('fail');
      onPaymentRequestFailed({ methodName, message: e.message });
    }
  };

  useEffect(() => {
    const initPaymentRequest = async () => {
      if (!stripe) return;

      const request = stripe.paymentRequest({
        country: 'US',
        currency: 'usd',
        total: {
          label: 'HeyDoctor',
          amount: amount * 100,
        },
      });

      request.on('token', handlePaymentRequestToken);

      const paymentRequestAvailable = await request.canMakePayment();

      if (paymentRequestAvailable) {
        setPaymentRequest(request);
        onPaymentRequestButtonDisplayed();
      }
    };

    initPaymentRequest();
  }, [stripe]);

  return paymentRequest ? <PaymentRequestButton options={{ paymentRequest }} /> : null;
};
